module.exports = __webpack_public_path__ + "static/img/WechatIMG8.f5f032e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/WechatIMG8.png
// module id = A9Dr
// module chunks = 11